module.exports = __webpack_public_path__ + "static/img/equipamiento-six-2.d957aa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/equipamiento-six-2.jpg
// module id = imhn
// module chunks = 1